import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "listings-header" }
const _hoisted_2 = { class: "listings-preview" }
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = { class: "listing-info" }
const _hoisted_5 = { class: "listing-price" }
const _hoisted_6 = { class: "listing-address" }
const _hoisted_7 = { class: "listing-id" }
const _hoisted_8 = {
  key: 0,
  class: "more-listings"
}

import { nodeViewProps, NodeViewWrapper } from "@tiptap/vue-3"


export default /*@__PURE__*/_defineComponent({
  __name: 'ListingsBlockComponent',
  props: nodeViewProps,
  setup(__props) {

const props = __props

// Helper function to get a value from listing or its attributes
const getValue = (listing: any, key: string): string => {
    const val = listing[key] || listing.attributes?.[key] || ""
    return String(val)
}

const getImageUrl = (listing: any): string => {
    return (
        listing.media?.[0]?.mediaURL ||
        listing.attributes?.media?.[0]?.mediaURL ||
        require("@/assets/icons/no_image.png")
    )
}

const getAddressLine = (listing: any): string => {
    return [
        getValue(listing, "streetNumber"),
        getValue(listing, "streetName"),
        getValue(listing, "streetSuffix"),
        listing.city,
        listing.stateOrProvince,
        getValue(listing, "postalCode"),
    ]
        .filter(Boolean)
        .join(" ")
}

const getFormattedPrice = (listing: any): string => {
    const price = getValue(listing, "listPrice")
    if (price) {
        return `$${Number(price).toLocaleString()}`
    }
    if (listing.attributes?.listPrice) {
        return `$${listing.attributes.listPrice.toLocaleString()}`
    }
    return "Contact for Price"
}

const getStatusText = (listing: any): string => {
    return getValue(listing, "standardStatus") || "No status"
}

const getStatusStyle = (listing: any) => {
    let backgroundColor = "#FEE2E2" // Default red background
    let color = "#991B1B" // Default red text

    if (listing.standardStatus === "Active" || listing.standardStatus === "Active Under Contract") {
        backgroundColor = "#D1FAE5" // Light green
        color = "#065F46" // Dark green
    } else if (listing.standardStatus === "Pending") {
        backgroundColor = "#FFEDD5" // Light orange
        color = "#C2410C" // Dark orange
    } else {
        backgroundColor = "#FEE2E2" // Red background for closed/other statuses
        color = "#991B1B" // Red text for closed/other statuses
    }

    return {
        backgroundColor,
        color,
    }
}

const deleteNode = () => {
    props.deleteNode()
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(NodeViewWrapper), {
    class: "listings-block",
    contenteditable: "false"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("h3", null, "📋 Property Listings Block", -1)),
        _createElementVNode("p", null, _toDisplayString(_ctx.node.attrs.listings.length) + " " + _toDisplayString(_ctx.node.attrs.listings.length === 1 ? "property" : "properties") + " will be included in the email ", 1),
        _createElementVNode("button", {
          onClick: deleteNode,
          class: "delete-button"
        }, _cache[0] || (_cache[0] = [
          _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
        ]))
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.node.attrs.listings.slice(0, 6), (listing) => {
          return (_openBlock(), _createElementBlock("div", {
            key: listing.listingId,
            class: "listing-card-preview"
          }, [
            _createElementVNode("img", {
              src: getImageUrl(listing),
              alt: getAddressLine(listing),
              class: "listing-image"
            }, null, 8, _hoisted_3),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", {
                class: "listing-status",
                style: _normalizeStyle(getStatusStyle(listing))
              }, _toDisplayString(getStatusText(listing)), 5),
              _createElementVNode("div", _hoisted_5, _toDisplayString(getFormattedPrice(listing)), 1),
              _createElementVNode("div", _hoisted_6, _toDisplayString(getAddressLine(listing)), 1),
              _createElementVNode("div", _hoisted_7, "ID: " + _toDisplayString(listing.listingId), 1)
            ])
          ]))
        }), 128)),
        (_ctx.node.attrs.listings.length > 6)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, " +" + _toDisplayString(_ctx.node.attrs.listings.length - 6) + " more properties ", 1))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})